import { RunConfig, RUNS } from '../../config/runs'

/**
 * End-of-run results overlay — shows time, top speed, and options to restart or switch runs.
 */

export class ResultsScreen {
  private overlay: HTMLDivElement
  private visible = false

  constructor() {
    this.overlay = document.createElement('div')
    this.overlay.style.cssText = `
      position: fixed; top: 0; left: 0; width: 100%; height: 100%;
      background: rgba(0,0,0,0.6); display: none; justify-content: center;
      align-items: center; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
      z-index: 100; backdrop-filter: blur(6px);
    `
    document.body.appendChild(this.overlay)
  }

  show(config: RunConfig, timeSeconds: number, topSpeedMph: number): void {
    if (this.visible) return
    this.visible = true

    const minutes = Math.floor(timeSeconds / 60)
    const seconds = (timeSeconds % 60).toFixed(1)
    const timeStr = minutes > 0 ? `${minutes}m ${seconds}s` : `${seconds}s`

    this.overlay.style.display = 'flex'
    this.overlay.innerHTML = `
      <div style="
        background: rgba(255,255,255,0.95); border-radius: 16px; padding: 40px 50px;
        text-align: center; color: #222; max-width: 420px; pointer-events: auto;
        box-shadow: 0 8px 40px rgba(0,0,0,0.3);
      ">
        <div style="font-size: 14px; text-transform: uppercase; letter-spacing: 2px; color: #888; margin-bottom: 8px;">
          Run Complete
        </div>
        <div style="font-size: 28px; font-weight: 800; margin-bottom: 24px;">
          ${config.name}
        </div>
        <div style="display: flex; justify-content: space-around; margin-bottom: 30px;">
          <div>
            <div style="font-size: 32px; font-weight: 700;">${timeStr}</div>
            <div style="font-size: 12px; color: #888; text-transform: uppercase;">Time</div>
          </div>
          <div>
            <div style="font-size: 32px; font-weight: 700;">${Math.round(topSpeedMph)}</div>
            <div style="font-size: 12px; color: #888; text-transform: uppercase;">Top Speed (mph)</div>
          </div>
        </div>
        <button id="results-restart" style="
          background: #1a5fb4; color: white; border: none; padding: 12px 32px;
          border-radius: 8px; font-size: 16px; font-weight: 600; cursor: pointer;
          margin-right: 10px;
        ">Run Again</button>
        <button id="results-menu" style="
          background: #555; color: white; border: none; padding: 12px 32px;
          border-radius: 8px; font-size: 16px; font-weight: 600; cursor: pointer;
        ">Switch Run</button>
        <div id="results-runs" style="
          margin-top: 20px; text-align: left; max-height: 150px; overflow-y: auto;
          display: none; font-size: 13px;
        "></div>
      </div>
    `

    document.getElementById('results-restart')!.addEventListener('click', () => {
      window.location.reload()
    })

    const menuBtn = document.getElementById('results-menu')!
    const runsDiv = document.getElementById('results-runs')!
    menuBtn.addEventListener('click', () => {
      if (runsDiv.style.display === 'none') {
        runsDiv.style.display = 'block'
        let html = ''
        for (const [id, run] of Object.entries(RUNS)) {
          html += `<a href="#" data-run="${id}" style="
            display: block; padding: 6px 8px; color: #222; text-decoration: none;
            border-radius: 4px; margin-bottom: 2px;
          " onmouseover="this.style.background='#eee'" onmouseout="this.style.background='transparent'"
          >${run.name}</a>`
        }
        runsDiv.innerHTML = html
        runsDiv.querySelectorAll('a').forEach(a => {
          a.addEventListener('click', (e) => {
            e.preventDefault()
            const runId = (a as HTMLElement).dataset.run!
            window.location.hash = runId
            window.location.reload()
          })
        })
      } else {
        runsDiv.style.display = 'none'
      }
    })
  }

  hide(): void {
    this.visible = false
    this.overlay.style.display = 'none'
  }

  get isVisible(): boolean {
    return this.visible
  }
}
